
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.784 24a.75.75 0 01-.75-.75c0-.827-.673-1.5-1.5-1.5s-1.5.673-1.5 1.5a.75.75 0 01-.75.75h-4.5a.75.75 0 01-.75-.75c0-.827-.673-1.5-1.5-1.5s-1.5.673-1.5 1.5a.75.75 0 01-.75.75h-3a.751.751 0 01-.75-.749 1.501 1.501 0 00-.866-1.354.751.751 0 01-.431-.752l1.85-19.117A2.246 2.246 0 014.327 0H19.67c1.16 0 2.122.871 2.238 2.025l1.854 19.157c.03.31-.13.601-.408.742a1.486 1.486 0 00-.821 1.329.75.75 0 01-.749.747h-3zm2.346-1.5a2.978 2.978 0 011.095-1.635L20.416 2.172a.746.746 0 00-.746-.672h-3.828l1.396 18.836A3.014 3.014 0 0119.44 22.5h1.69zm-7.5 0a3.03 3.03 0 012.105-2.139L14.338 1.5H9.731L8.334 20.361a3.03 3.03 0 012.105 2.139h3.191zm-9 0a3.014 3.014 0 012.202-2.164L8.227 1.5h-3.9a.747.747 0 00-.746.675L1.777 20.814A2.985 2.985 0 012.938 22.5H4.63z"}})])
          )
        }
      }
    